module.exports = "/images/pencil-modify-report.svg?d36f59b3fa629463aa603e653df8629d";